import { CountUp } from "countup.js";
import Vivus from "vivus";
import { notFound } from "../utils/notFoundImage";
import { JsPaginationController } from "../utils/pagination";
import { FilterHandler } from "./filterHandler";
import { htmlDecode } from "../utils/htmlUtils";
import { parseISO, format, isAfter } from "date-fns";
import { initTooltips } from "../utils/bootstrapUtils";
import pluralize from "pluralize";
import { ajaxErrorPopUp } from "../utils/alerts";
import { Modal } from "bootstrap";

const numberFormatter = new Intl.NumberFormat("en-GB");

function getCard(product) {
    const imgSrc = product.images.length > 0 ? product.images[0] : notFound;

    const col = document.createElement("div");
    // row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xxl-4
    col.classList.add("col", "mb-3");
    const name = htmlDecode(product.productName);
    let dateAvailableDiv = ``;
    if(product.dateAvailable)
    {
        try {
            const dateAvailable = parseISO(product.dateAvailable);
            const isFutureDate = isAfter(dateAvailable, new Date());
            const title = isFutureDate ? `This item will become available on ${format(dateAvailable, "dd/MM/yy")}` : `This item became available on ${format(dateAvailable, "dd/MM/yy")}`;
            const dateColour = isFutureDate ? "text-warning" : "";

            dateAvailableDiv =  `<div class="d-flex align-items-center" data-bs-toggle="tooltip" title="${title}">
                                    <svg class="svg-icon me-2 h6 icon-tertiary small mb-0"><use xlink:href="/sprites/solid.svg#calendar"></use></svg>
                                    <span class="h6 small mb-0 ${dateColour}">${format(dateAvailable, "dd/MM/yy")}</span>
                                </div>`;
        }
        catch (e) {
            console.warn(`Could not parse date ${product.dateAvailable} for product ${product.id}`, e);
        }
    }
    //card.classList.add("card", "shadow", "h-100");


    //Categories markup
    const categoriesContainer = document.createElement("div");
    categoriesContainer.classList.add("align-items-center");
    const categoryBadges = product.categories.slice(0, 3).map(i => `<span class="m-1 badge badge-sm bg-gray-300 text-dark text-wrap">${i}</span>`).join("\n");
    const categoryToolTipContent = product.categories.slice(3, product.categories.length).map(i => `<span class='m-1 badge badge-sm bg-gray-300 text-dark text-wrap'>${i}</span>`).join("\n");
    const categoryTooltip = product.categories.length > 3 ? `<a class="btn btn-link btn-sm" data-bs-toggle="tooltip" data-bs-placement="top" data-bs-html="true" data-bs-title="${categoryToolTipContent}">+${pluralize('category', product.categories.length - 3, true)}</a>` : '';
    categoriesContainer.innerHTML = `${categoryBadges} ${categoryTooltip}`;
    const isWantedItem = product.providedByName === 'Wanted Item';
    // I don't like this hard-coded path for the product page but, I can't see a viable alternative at the moment.
    col.innerHTML = `<div href="/Products/${product.id}" id="${product.id}" class="card shadow h-100 animate-up-3">
        <a href="/Products/${product.id}"><img class="rounded-top cover w-100" src="${imgSrc}" alt="${name}" onerror="this.src='${notFound}'; this.removeAttribute('onerror');" style="height: 200px;" /></a>
        <div class="card-body d-flex flex-column ${isWantedItem ? 'bg-primary-subtle' : 'bg-gray-100'} border-top border-gray-300 p-2">
            <div class="d-flex align-items-center justify-content-between flex-wrap mb-3">
                <span class="badge ${isWantedItem ? 'bg-primary' : 'bg-gradient-dark'} mb-0">${product.providedByName}</span>
                ${dateAvailableDiv}
            </div>
            <h5 class="card-title line-clamp-3 px-2">${name}</h5>
            ${categoriesContainer.outerHTML}
        </div>
        <div class="card-footer bg-white p-0 ">
            <a class="btn btn-block btn-primary animate-up-1 rounded-bottom rounded-0 w-100" href="/Products/${product.id}"href="/Products/${product.id}">
                More info
            </a>
        </div>
    </div>`;

    // Attach a custom gtag event when the user clicks on the product.
    col.querySelectorAll("a").forEach(e => e.addEventListener("click", function () {
        if (typeof (gtag) !== "undefined") {
            const url = new URL(window.location);
            gtag("event", "select_product", {
                product_id: product.id,// The ID of the product the user clicked on 
                product_provider: product.providedByName, // Who the provider of the product is
                product_found_with: url.searchParams.has("search") ? url.searchParams.get("search") || "browsing" : "browsing", // What search term the user used to find this product
                search_conversions: 1
            });
        }
    }));

    return col;
}

function addCard(product) {
    var cardContainer = document.getElementById("product-card-container");
    cardContainer.append(getCard(product));
}

function clearCards() {
    document.getElementById("product-card-container").innerHTML = "";
}

function hideAllContainersBut(type) {
    document.querySelectorAll(`#all-products div[data-container-type]:not([data-container-type='${type}'])`).forEach(e => e.classList.toggle("d-none", true));
    document.querySelectorAll(`#all-products div[data-container-type='${type}']`).forEach(e => e.classList.toggle("d-none", false));
}

let paginationController = new JsPaginationController("nav ul.pagination");

function setPage(page, setPagination = false) {
    const url = new URL(window.location);
    url.searchParams.set("page", page);
    window.history.pushState({}, "", url);

    if (setPagination) {
        paginationController.page = page;
        paginationController.refresh();
    }
}

/**
 * 
 * @param {Event} e 
 * @param {*} pushStateInsteadOfReplace 
 */
function updatePageWithSearchOrFilters(e, pushStateInsteadOfReplace) {
    e.preventDefault();

    const url = new URL(window.location);
    let params = new URLSearchParams(window.location.search);

    //url.searchParams.set("page", 1); // Reset page back to 1 when we update the search/filters
    params.delete("page");

    // Force pagination refresh
    paginationController.page = 1;
    paginationController.refresh();

    Array.from(document.querySelectorAll("#search-form input")).forEach(e => {
        if (e.value) params.set(e.getAttribute("name"), e.value); // If we have a value, add it
        else if (params.get(e.getAttribute("name"))) params.delete(e.getAttribute("name")); // Otherwise, if there's something in the url with the name but we don't currently have a value remove it from the url
    });

    // Object<string, array>
    // string = filter name
    // array = array of values
    /** @type Object<string, string[]> */
    const filters = Array.from(document.querySelectorAll("div[data-filters] input[type='checkbox'][data-filter], input[type='number'][data-filter]"))
        .reduce((curr, ele) => {
            const filterName = ele.getAttribute("data-filter");
            if (!Object.keys(curr).includes(filterName)) {
                curr[filterName] = [];
            }
            if(ele.type == "number" && ele.value) {
                curr[filterName].push(ele.value);
                return curr;
            }
            
            if (ele.checked) curr[filterName].push(ele.value);

            return curr;
        }, {});
    
    if (e.target.type == "checkbox") {
        const filterType = e.target.dataset.filter;
        const val = e.target.value;
        const checked = e.target.checked;
        if (!checked) {
            filters[filterType] = filters[filterType].filter(x => x != val);
        }
    }
    
    // For each of the filters in the object, we want to empty the url params (if there is any) and then append the values we need onto it.
    for (const filterName in filters) {
        if (params.getAll(filterName)) { // We have a value in the url
            params.delete(filterName); // Remove it
        }

        // For each of the values in the array, add it. Outcome looks something like `&providers=ID1&providers=ID2`.
        filters[filterName].forEach(v => params.append(filterName, v));
    }

    url.search = params;

    // Push everything to history so our url changes without a page reload. 
    // Allows us to only init filters once and provide a nice  shareable url to the users ;)
    window.history.pushState(null, "", url);

    // Need to manually send this off again... Think this is because GA4 is still in beta?
    // eslint-disable-next-line no-undef
    if (typeof gtag !== "undefined") {
        // eslint-disable-next-line no-undef
        gtag("event", "view_search_results", {
            "search_term": params.get("search"),
            "q_location": params.get("location"),
            "q_categories": params.getAll("categories")
        });
    }
}

function validateQuantityRange(){
    
    const min = document.getElementById("QuantityMin");
    const minVal = parseInt(min.value);
    const max = document.getElementById("QuantityMax");
    const maxVal = parseInt(max.value);
    
    if(minVal > maxVal){
        console.log("min > max");
        max.value = minVal;
        min.value = maxVal;
    }
    else if (maxVal < minVal){
        console.log("max < min")
        min.value = maxVal;
        max.value = minVal;
    }
}

export { paginationController };

window.addEventListener("DOMContentLoaded", function () {
    const filterParent = document.querySelector("#filterAccordion #filterCollapse div.accordion-body");
    const filterModal = document.querySelector("#modalFilters");

    let loader = document.querySelector("#loading-logo");
    let viv;
    if (loader) {
        viv = new Vivus(loader, { type: "sync", duration: 100, animTimingFunction: Vivus.EASE }, (v) => {
            v.play(v.getStatus() === "end" ? -1 : 1);
        });
    }

    const filterHandler = new FilterHandler(filterParent, filterModal, (e) => {
        if(e.target.name.includes("Quantity"))
            validateQuantityRange();
        
        updatePageWithSearchOrFilters(e);
        fetchProducts();
    });

    const stopLoading = (showNotFound) => {
        if (viv) {
            viv.stop();//.destroy();
        }

        if (showNotFound) {
            hideAllContainersBut("nodata");
        } else {
            hideAllContainersBut("data");
        }

        filterHandler.filtersLoading(false);
    };

    const startLoading = () => {
        if (viv) {
            viv.play(1);//.destroy();
        }

        hideAllContainersBut("loading");
        filterHandler.filtersLoading(true);
    };

    const fetchProducts = async () => {
        startLoading();

        clearCards();

        const url = new URL(document.getElementById("product-card-container").dataset.api);
        // Move our parameters over
        const queryString = window.location.search;
        let params = new URLSearchParams(queryString);
        url.search = params;

        const filterUrl = new URL(document.getElementById("product-card-container").dataset.filterApi);
        filterUrl.search = params;

        try {
            const filterPromise = fetch(filterUrl);

            const r = await fetch(url, { method: "GET" });
            const pagedResponse = await r.json();
            if (!r.ok) {
                console.error("Cannot get products", r.status, r.statusText);
                ajaxErrorPopUp(r.status, pagedResponse.detail, pagedResponse.title);

                stopLoading(true);
                return;
            }


            var itemCounts = Array.from(document.querySelectorAll(".item-count"));
            itemCounts.forEach(e => {
                if (e.textContent != numberFormatter.format(pagedResponse.total)) { // Only if it's updated
                    const numAnim = new CountUp(e, pagedResponse.total);
                    numAnim.start();
                    e.parentElement.querySelector("span.item-unit").innerHTML = pluralize('item', numberFormatter.format(pagedResponse.total));

                }
            });
            paginationController.updateTotal(Math.ceil(pagedResponse.total / 21));

            const newFilterData = await (await filterPromise).json();
            //console.log("Updating filters", newFilterData);
            //initaliseFilter(filterParent, filterModal, newFilterData);

            // updateFilters(filterParent, filterModal, newFilterData, (e) => {
            //     updatePageWithSearchOrFilters(e);
            //     fetchProducts();
            // });
            filterHandler.updateFilters(newFilterData);

            pagedResponse.results.forEach(p => addCard(p));
            stopLoading(pagedResponse.total == 0);
            initTooltips();
        } catch (e) {
            console.error(e);
        }
    };

    paginationController.updateOnPageSelect(async (newPage, paginationClicked) => {
        setPage(newPage);
        await fetchProducts();

        if (paginationClicked.dataset.scroll) {
            if (this.document.querySelector(paginationClicked.dataset.scroll)) {
                this.document.querySelector(paginationClicked.dataset.scroll).scrollIntoView();
            } else {
                this.window.scrollTo(0, 0);
            }
        }
    });

    if (document.getElementById("search-form")) {
        const form = document.getElementById("search-form");
        //searchFormSuggestions();
        //form.onsubmit = updatePageWithSearchOrFilters;
        form.addEventListener("submit", (e) => {
            updatePageWithSearchOrFilters(e);
            fetchProducts();
        });
    }

    const urlParams = new URLSearchParams(window.location.search);
    let currentPage = 1;

    if (urlParams.has("page")) {
        const pageParam = Number.parseInt(urlParams.get("page"), 10);

        if (Number.isNaN(pageParam)) {
            // Re-set the page to a number...
            setPage(1);
        } else {
            if (pageParam > 0) {
                currentPage = pageParam;
            } else {
                setPage(1);
            }
        }
    }

    paginationController.page = currentPage;
    paginationController.refresh();
    fetchProducts();

    //Modal.getOrCreateInstance(filterModal).show();
});